import type { SupplySource } from '@type/medication.type'

type WithSupply = { attributes: { supply_source?: SupplySource | string | null } }

/** The patient buys this medicine outside: the pharmacy never verifies, fills or bills it. */
export const isOutsideSupply = (med: WithSupply | undefined | null) => med?.attributes?.supply_source === 'outside'

/** Pharmacy work queues (verify, fill) without the orders the patient buys outside. */
export const excludeOutsideSupply = <T extends WithSupply>(meds: T[]) => meds.filter(med => !isOutsideSupply(med))

export const BUY_OUTSIDE_LABEL = 'Buy outside'
export const BUY_OUTSIDE_PRINT_NOTE = 'Buy outside — not supplied by the hospital pharmacy'
